<template>
  <div class="pageSize">
    <span>{{total}} Records</span>
    <el-select v-model="pageSize" size="small" @change="sizeChange">
        <el-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <span> Records per Page</span>
  <el-pagination
      background
      @current-change="currentChange"
      layout="prev, pager, next"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total">
    </el-pagination>

  </div>
</template>

<script>
export default {
  name: 'Page',
  props: {
    handleSizeChange: {
      type: Function
    },
    handleCurrentChange: {
      type: Function
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      options: [20, 40, 60, 100],
      value: this.pageSize
    }
  },
  created() {

  },
  methods: {
    sizeChange(val) {
      this.value = val
      this.$emit('handleSizeChange', val)
    },
    currentChange(val) {
      this.$emit('handleCurrentChange', val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #000000;
  color: #ffffff !important;
}
.pageSize{
  width: auto;
  padding: 20px 0px 0px 0px !important;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.el-select{
  width: 70px;
  margin: 0 10px;
}
@media screen and (max-width: 800px) {

}
</style>



// WEBPACK FOOTER //
// src/pages/components/pagination.vue